<form class="integration-form" [ngClass]="{'was-validated': frm.submitted}"
      novalidate #frm="ngForm" (ngSubmit)="onSubmit()">
  <div class="form-card">
    <div class="form-brand">
      <span class="ifood-mark"><img src="/assets/icons/logo-ifood.png" alt="iFood"></span>
      <div>
        <h3>{{integracaoIfood.nova ? 'Vincular uma nova loja' : (integracaoIfood.nomeLoja || 'Configurar integração')}}</h3>
        <p>{{integracaoIfood.nova ? 'Escolha o aplicativo, configure a integração e autorize a loja.' : 'Revise as APIs e a configuração desta loja.'}}</p>
      </div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="obrigarBandeiras()">
      Para usar as APIs de pedidos ou entrega, ative as formas de pagamento com bandeiras.
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="mensagemErro">
      <div class="d-flex align-items-center justify-content-between">
        <span>{{mensagemErro}}</span>
        <button type="button" class="close" aria-label="Fechar" (click)="fecharAlerta()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>

    <section class="form-section" *ngIf="integracaoIfood.nova; else aplicativoAtual">
      <div class="section-heading">
        <span class="step-number">1</span>
        <div><h4>Selecione o aplicativo iFood</h4><p>Escolha os serviços que serão autorizados para esta loja.</p></div>
      </div>

      <div class="app-grid">
        <button class="app-option" type="button"
                [class.selected]="appIfoodSelecionado === APP_IFOOD_CATALOGO"
                [disabled]="ifooodUserCode?.id" (click)="selecionarApp(APP_IFOOD_CATALOGO)">
          <span class="app-icon"><i class="fas fa-cube"></i></span>
          <span><strong>Meu Cardápio — Catálogo</strong><small>Acesse os recursos de catálogo da loja.</small></span>
          <i class="fas fa-check-circle selected-icon"></i>
        </button>
        <button class="app-option" type="button"
                [class.selected]="appIfoodSelecionado === APP_IFOOD_PEDIDOS"
                [disabled]="ifooodUserCode?.id" (click)="selecionarApp(APP_IFOOD_PEDIDOS)">
          <span class="app-icon order"><i class="fas fa-shopping-cart"></i></span>
          <span><strong>Meu Cardápio — Completo</strong><small>Catálogo, pedidos e entregadores parceiros.</small></span>
          <i class="fas fa-check-circle selected-icon"></i>
        </button>
      </div>
    </section>

    <ng-template #aplicativoAtual>
      <section class="current-app">
        <span class="app-icon"><i class="fas fa-puzzle-piece"></i></span>
        <div><small>Aplicativo autorizado</small><strong>{{descricaoApp()}}</strong></div>
        <span class="merchant-summary">Merchant ID: <b>{{integracaoIfood.idLoja}}</b></span>
      </section>
    </ng-template>

    <ng-container *ngIf="appIfoodSelecionado">
      <section class="form-section services-section">
        <div class="section-heading">
          <span class="step-number">{{integracaoIfood.nova ? '2' : '1'}}</span>
          <div><h4>APIs da integração</h4><p>Confira as APIs disponíveis para o aplicativo autorizado.</p></div>
        </div>

        <div class="service-grid">
          <article class="service-option catalog catalog-service" [class.enabled]="catalogApiAtiva()">
            <div class="catalog-api-row">
              <span class="service-icon"><i class="fas fa-cube"></i></span>
              <div class="service-copy">
                <strong>Catalog API</strong>
                <small>Permite consultar e manter o catálogo da loja no iFood.</small>
              </div>
              <span class="service-status" [class.disabled]="!catalogApiAtiva()">
                {{catalogApiAtiva() ? 'Ativa' : 'Inativa'}}
              </span>
            </div>

            <div class="catalog-publication-control" *ngIf="catalogApiAtiva()"
                 [class.enabled]="integracaoIfood.publicacaoCatalogoHabilitada">
              <span class="publication-control-icon"><i class="fas fa-upload"></i></span>
              <div class="service-copy">
                <strong>Publicação de catálogo</strong>
                <small>Habilita publicação, pausa e atualização de produtos, categorias e adicionais no iFood pelo catálogo do Meu Cardápio.</small>
              </div>
              <kendo-switch name="publicacaoCatalogoHabilitada"
                            [(ngModel)]="integracaoIfood.publicacaoCatalogoHabilitada"
                            [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            </div>
          </article>

          <article class="service-option order" *ngIf="appIfoodSelecionado === APP_IFOOD_PEDIDOS"
                   [class.enabled]="integracaoIfood.orderApi">
            <span class="service-icon"><i class="fas fa-shopping-cart"></i></span>
            <div class="service-copy">
              <strong>Order API</strong>
              <small>Importa e gerencia pedidos do iFood no Meu Cardápio.</small>
            </div>
            <kendo-switch name="orderApi" [(ngModel)]="integracaoIfood.orderApi"
                          [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
          </article>

          <article class="service-option shipping" *ngIf="appIfoodSelecionado !== APP_IFOOD_CATALOGO"
                   [class.enabled]="integracaoIfood.shippingApi">
            <span class="service-icon"><i class="fas fa-truck"></i></span>
            <div class="service-copy">
              <strong>Shipping API</strong>
              <small>Solicita entregadores parceiros do iFood.</small>
            </div>
            <kendo-switch name="shippingApi" [(ngModel)]="integracaoIfood.shippingApi"
                          [disabled]="appIfoodSelecionado === APP_IFOOD_LOGISTICA"
                          [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
          </article>
        </div>

        <div class="shipping-options" *ngIf="integracaoIfood.shippingApi">
          <label class="check-option">
            <input name="solicitarAutomatico" type="checkbox" kendoCheckBox
                   [(ngModel)]="integracaoIfood.solicitarAutomatico">
            <span><strong>Solicitar entregador automaticamente</strong><small>Faz a solicitação quando o pedido entrar em preparação.</small></span>
          </label>
          <label class="check-option" *ngIf="!integracaoIfood.solicitarAutomatico">
            <input name="confirmarCotacao" type="checkbox" kendoCheckBox
                   [(ngModel)]="integracaoIfood.confirmarCotacao">
            <span><strong>Confirmar a cotação antes de solicitar</strong><small>Exibe a cotação para revisão antes de pedir o entregador.</small></span>
          </label>
        </div>
      </section>

      <section class="form-section" *ngIf="integracaoIfood.nova">
        <div class="section-heading">
          <span class="step-number">3</span>
          <div><h4>Autorize a loja</h4><p>Gere o link, autorize no iFood e informe o código recebido.</p></div>
        </div>

        <div class="authorization-link">
          <button class="btn btn-outline-primary" type="button" (click)="gereLinkAutorizacao()"
                  [disabled]="gerandoLink || ifooodUserCode?.id || obrigarBandeiras()">
            <i class="fas mr-1" [ngClass]="{'fa-link': !gerandoLink, 'fa-spinner fa-spin': gerandoLink}"></i>
            {{gerandoLink ? 'Gerando...' : 'Gerar link de autorização'}}
          </button>
          <input kendoTextBox name="verificationUrl" class="form-control" readonly
                 [(ngModel)]="ifooodUserCode.verificationUrl" placeholder="O link aparecerá aqui">
          <a class="btn btn-primary" target="_blank" rel="noopener"
             [href]="ifooodUserCode.verificationUrl" *ngIf="ifooodUserCode.verificationUrl">Abrir link</a>
        </div>

        <div class="authorization-fields" *ngIf="ifooodUserCode.verificationUrl">
          <div class="form-group">
            <label for="codigoAutorizacao">Código de autorização</label>
            <input kendoTextBox id="codigoAutorizacao" name="codigoAutorizacao" class="form-control"
                   [(ngModel)]="ifooodUserCode.codigoAutorizacao" required
                   placeholder="Informe o código gerado pelo iFood">
            <div class="invalid-feedback">Campo obrigatório.</div>
          </div>
          <div class="form-group">
            <label for="idLojaIfood">Merchant ID <small>(opcional)</small></label>
            <input kendoTextBox id="idLojaIfood" name="idLojaIfood" class="form-control"
                   [(ngModel)]="ifooodUserCode.idLoja" placeholder="Selecione uma loja específica">
          </div>
        </div>
      </section>
    </ng-container>

    <footer class="form-actions" *ngIf="!integracaoIfood.nova || ifooodUserCode.verificationUrl">
      <button class="btn btn-light" type="button" (click)="cancelar()" [disabled]="salvando">Cancelar</button>
      <button class="btn btn-primary" type="submit"
              [disabled]="salvando || obrigarBandeiras() || (integracaoIfood.nova && !ifooodUserCode.codigoAutorizacao)">
        <i class="fas fa-spinner fa-spin mr-1" *ngIf="salvando"></i>
        {{integracaoIfood.nova ? 'Autorizar e adicionar loja' : 'Salvar alterações'}}
      </button>
    </footer>
  </div>
</form>
